const services = [
  {
    id: 1,
    icon: 'ri-home-heart-line',
    title: '教室レッスン',
    description: '明るく楽しい教室で、みんなでワイワイ料理を学びましょう！',
    color: 'from-orange-400 to-red-400',
    borderColor: 'border-orange-300',
    bgColor: 'bg-orange-50',
    features: [
      '基礎から学べる初心者コース',
      '季節の食材を使った料理',
      '和食・洋食・中華など多彩なメニュー',
      '少人数制でしっかりサポート'
    ],
    image: 'https://readdy.ai/api/search-image?query=Cheerful%20cooking%20class%20with%20students%20learning%20together%20in%20bright%20kitchen%2C%20instructor%20demonstrating%20cooking%20techniques%2C%20colorful%20fresh%20ingredients%20on%20counter%2C%20happy%20people%20enjoying%20culinary%20education%2C%20warm%20inviting%20classroom%20atmosphere%2C%20magazine%20style%20food%20photography%20with%20playful%20composition%2C%20natural%20lighting%20and%20vibrant%20colors&width=600&height=400&seq=service-class&orientation=landscape'
  },
  {
    id: 2,
    icon: 'ri-map-pin-user-line',
    title: '訪問型レッスン',
    description: 'ご自宅のキッチンで、マンツーマンの丁寧な指導を受けられます！',
    color: 'from-red-400 to-pink-400',
    borderColor: 'border-red-300',
    bgColor: 'bg-red-50',
    features: [
      'ご自宅で気軽にレッスン',
      'お好きな時間に予約可能',
      '使い慣れたキッチンで学べる',
      '家族みんなで参加OK'
    ],
    image: 'https://readdy.ai/api/search-image?query=Private%20home%20cooking%20lesson%20with%20instructor%20teaching%20in%20cozy%20residential%20kitchen%2C%20one-on-one%20culinary%20instruction%2C%20comfortable%20home%20environment%2C%20personalized%20cooking%20education%2C%20warm%20friendly%20atmosphere%2C%20magazine%20editorial%20style%20with%20soft%20natural%20lighting%2C%20inviting%20domestic%20kitchen%20setting&width=600&height=400&seq=service-visit&orientation=landscape'
  },
  {
    id: 3,
    icon: 'ri-plant-line',
    title: '食育プログラム',
    description: '食材の選び方から栄養バランスまで、食の大切さを楽しく学べます！',
    color: 'from-green-400 to-emerald-400',
    borderColor: 'border-green-300',
    bgColor: 'bg-green-50',
    features: [
      '食材の見分け方・選び方',
      '栄養バランスの基礎知識',
      '旬の食材を活かす方法',
      '食品保存のコツ'
    ],
    image: 'https://readdy.ai/api/search-image?query=Educational%20food%20nutrition%20class%20showing%20fresh%20organic%20vegetables%20and%20fruits%2C%20instructor%20explaining%20ingredient%20selection%2C%20colorful%20produce%20display%2C%20healthy%20eating%20education%2C%20vibrant%20farmers%20market%20style%20arrangement%2C%20magazine%20layout%20with%20cheerful%20educational%20atmosphere%2C%20natural%20wholesome%20food%20photography&width=600&height=400&seq=service-education&orientation=landscape'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-orange-50/30 to-white relative overflow-hidden">
      <div className="absolute top-10 right-10 w-32 h-32 opacity-10">
        <i className="ri-restaurant-line text-orange-300 text-9xl"></i>
      </div>
      <div className="absolute bottom-10 left-10 w-32 h-32 opacity-10">
        <i className="ri-cake-3-line text-red-300 text-9xl"></i>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white px-5 py-2.5 rounded-full shadow-lg mb-6 border-2 border-orange-300" style={{ borderStyle: 'dashed' }}>
            <i className="ri-book-open-line text-orange-500"></i>
            <span className="text-orange-600 font-medium" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              Our Lessons
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Klee One", cursive' }}>
            レッスン内容
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            あなたに合ったスタイルで、料理の楽しさを発見しましょう！
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className={`bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer border-4 ${service.borderColor}`}
              style={{ 
                animationDelay: `${index * 100}ms`,
                borderStyle: 'dashed'
              }}
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute top-4 right-4 w-16 h-16 bg-gradient-to-br ${service.color} rounded-full flex items-center justify-center shadow-lg border-3 border-white`} style={{ borderWidth: '3px' }}>
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
              </div>
              
              <div className={`p-6 ${service.bgColor}`}>
                <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>
                  {service.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                  {service.description}
                </p>
                
                <ul className="space-y-2.5">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-gray-700">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-orange-500 text-lg"></i>
                      </div>
                      <span className="ml-2" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-10 py-4 rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer font-bold text-lg shadow-lg"
            style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
          >
            <i className="ri-chat-smile-3-line mr-2"></i>
            レッスンについて相談する
          </button>
        </div>
      </div>
    </section>
  );
}
